<template>
  <form data-abide2 novalidate data-vv-scope="form5" @submit.prevent="submitForm" dusk="registration-step-5" class="step" :style="{'justify-content':buttonToTop ? 'flex-start' : 'center','flex-flow' : buttonToTop ? 'column' : 'wrap'}">
      <div class="form-inner">
        <div class="headline" v-html="trans('reg.enter_email_address')"></div>
        <!-- Password needed for saving credentials in browser -->
        <input style="position: absolute;opacity: 0;z-index: -1" dusk="password" autocomplete="current-password" type="password" name="password" :value="password" />
        <label>
          <input class="form-control dark"
                 type="email"
                 dusk="login"
                 autocomplete="username"
                 id="email"
                 v-bind:placeholder="trans('email')"
                 v-bind:data-vv-as="trans('email').toLowerCase()"
                 required
                 v-model="email"
                 v-validate="'required|email'"
                 :class="{'is-invalid-input': errors.has('form5.email')}"
                 name="email">

          <span class="form-error" :class="{'is-visible': errors.has('form5.email')}">
                          {{ errors.first('form5.email') }}
                        </span>
        </label>
      </div>
      <div class="form-footer">
        <button :disabled="!email || errors.has('form5.email')" class="btn btn-primary btn-long btn-rounded" id="button5" type="submit">
          {{ trans('reg.finish') }}
        </button>
      </div>
  </form>
</template>

<script>
import _ from "lodash";
import { VueReCaptcha } from 'vue-recaptcha-v3'
export default {
  mixins: [require('@general/lib/mixin').default],
  props: ['vars'],
  data() {
    return this.vars;
  },
  components: {
    VueReCaptcha
  },
  methods: {

    async recaptcha() {
      await this.$recaptchaLoaded()

      return await this.$recaptcha('login')
    },

    decode : function () {
      const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      let input = document.head.querySelector("[name=hash][content]").content;
      let input_secret = document.head.querySelector("[name=hash_secret][content]").content;
      var n = input_secret.slice(-1);
      let index = input_secret.length;
      input = input.substring(0, index-1) + n + input.substring(index);
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      while (i < input.length) {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      let utftext = output;
      var string = "";
      var i = 0;
      let c = 0;
      let c1 = 0;
      let c2 = 0;
      let c3 = 0;
      while ( i < utftext.length ) {
        c = utftext.charCodeAt(i);
        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        }
        else if((c > 191) && (c < 224)) {
          c2 = utftext.charCodeAt(i+1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
        }
        else {
          c2 = utftext.charCodeAt(i+1);
          c3 = utftext.charCodeAt(i+2);
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
          i += 3;
        }
      }
      return string;
    },
    async submitForm(e) {
      e.preventDefault();

      this.showLoadingButton('#button5')

      let response = await axios.post('/api/register/validate-email', {email: this.email})
      if (response.data.success) {
        if(this.location_type === 'error'){
          try{
            let response = await axios.post('/api/register/find-location')
            if (response.status === 200) {
              this.country_code = response.data.country_code;
              this.locality = response.data.locality;
              this.state = response.data.state;
              this.country = response.data.country;
              this.lat = response.data.lat;
              this.lng = response.data.lng;
              this.address = response.data.address;
              this.location_type = 'manual';
            }
          }catch (e){
            this.location_type = 'manual';
            this.step = 'locality';
            this.mapVisible = true;
            if(this.addressError){
              this.addressShow = this.trans('reg.location_defining');
              this.addressError = '';
              if(this.address){
                this.addressShow = this.address;
              }
            }
            this.restoreLoadingButton('#button5')
            return false;
          }
        }
        let campaigns_list = [
            'barebuddy'
        ];
        let campaign = null;
        $.each(campaigns_list,function (key,val){
          if(window.location.href.indexOf(val) !== -1){
            campaign = val;
          }
        })
        const token = await this.recaptcha();
        this.decode();
        let data = {
          handle: this.handle,
          email: this.email,
          password: this.password,
          dob: this.dob,
          headline: this.nickname,
          terms: this.acceptTerms,
          honeypot: this.honeypot.value,
          lang: app.lang,
          lat: this.lat,
          lng: this.lng,
          address: this.address,
          country: this.country,
          country_code: this.country_code,
          location_type: this.location_type,
          locality: this.locality,
          state: this.state,
          recaptcha: token,
          key: this.decode()
        }
        if(campaign){
          data.campaign = campaign;
        }

        if (this.avatarPhoto) {
          data.photo = this.avatarPhoto
          data.actions = JSON.stringify(this.avatarActions)
        }

        let formData = this.getFormData(data)
        try {
          let response = await axios.post('/api/register/validateAndRegister', formData)
          if (response.status === 200) {
            //after getting data and till reloading page button must be in loading mode
            //this.showLoadingButton('#button5')

            await auth.login(this.email, this.password)

            if (app.isDesktop) {
              this.step = 'welcome';
            }else{
              window.history.pushState({'id': 1}, '/welcome', '/welcome');
              window.location.reload();
            }
          }
        } catch (error) {
          let errorFields = error.data.fields
          if (_.intersection(errorFields, ['email', 'password', 'dob']).length !== 0) {
            this.step = 1;
            return false;
          } else if (_.intersection(errorFields, ['photo']).length !== 0) {
            this.step = 2;
            return false;
          } else if (_.intersection(errorFields, ['terms', 'captcha']).length !== 0) {
            this.step = 3;
            return false;
          }

          if (error.status === 422) {
            this.showErrorNotification(error.data.error)
          }
          if (error.data.error === 'maintenance_mode') {
            this.showErrorNotification(error.data.message)
          }
          this.restoreLoadingButton('#button5')
        }
      }else{
        this.restoreLoadingButton('#button5')
        this.errors.add({
          field: 'form5.email',
          msg: response.data.errors.email[0]
        });
        let emailError = function(e){
          this.errors.clear();
          document.getElementById('button5').removeEventListener('click', emailError);
        }
        document.getElementById('button5').addEventListener('keyup', emailError);
      }
    },
  },
  mounted() {
    let email = document.getElementById('email');

    let self = this;
    if(this.isMobile) {
      email.addEventListener("focus", () => {
        self.buttonToTop = true;
      })
      email.addEventListener("blur", () => {
        self.buttonToTop = false;
      })
      document.getElementById('button5').addEventListener('touchend', (e) => {
        if(!(!this.email || this.errors.has('form5.email'))){
          this.submitForm(e)
        }
      });
    }

    if(this.buttonToTop || this.isDesktop) {
      document.getElementById('email').focus();
    }
  },
}
</script>
